import { FormikProvider, useFormik } from 'formik';
import { PropsWithChildren } from 'react';

import * as graphql from '@treams/treams-network';

export default function EmployeesContextProvider(props: PropsWithChildren<{}>) {
	const formik = useFormik({
		initialValues: {
			status: [graphql.UserStatus.Active],
			query: '',
			groupIDs: [] as string[],
			cycleTemplateIDs: [] as string[],
			jobTitleIDs: [] as string[],
			isExternal: '',
		},
		onSubmit: () => {},
	});

	return <FormikProvider value={formik}>{props.children}</FormikProvider>;
}
